// CLIC A WHATSAPP (22-oct-2026). Carga en todas las páginas (layout/theme.liquid).
// La etiqueta de Google de la app «Google & YouTube» corre dentro del sandbox de píxeles de Shopify
// y la página no tiene window.gtag, así que aquí se carga gtag.js propio, SIN vista de página
// (send_page_view:false), solo para mandar la conversión secundaria «Clic a WhatsApp» de Google Ads
// y el evento GA4 «clic_whatsapp». Se dispara al hacer clic en un enlace a wa.me, api.whatsapp.com,
// web.whatsapp.com o whatsapp://, o en el botón de WhatsApp de la cabecera. No cambia el enlace ni
// detiene el clic. Deduplicación: un envío cada 3 s por página (doble toque, dos escuchas).
// Consentimiento: si Shopify dice que no hay permiso de marketing no va la conversión, y si no hay
// permiso de analítica no va el evento GA4. Sin la API de privacidad de Shopify se envía (Venezuela
// no pide aviso de cookies).
(function(){
  if (window.__ffClicWa) return; window.__ffClicWa = true;
  var AW='AW-18485152648', SEND_TO='AW-18485152648/vdUjCN6y_qUdEIiXtO5E', GA4='G-F59TXMPBK2';
  var RE=/^(https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\/|whatsapp:)/i;
  var cargado=false, ultimo=0;
  window.dataLayer=window.dataLayer||[];
  function gtag(){ window.dataLayer.push(arguments); }
  function permiso(tipo){
    try{
      var p=window.Shopify && window.Shopify.customerPrivacy;
      if(!p) return true;
      var f = tipo==='marketing' ? p.marketingAllowed : p.analyticsProcessingAllowed;
      return typeof f==='function' ? f.call(p)!==false : true;
    }catch(e){ return true; }
  }
  function cargar(){
    if(cargado) return; cargado=true;
    var s=document.createElement('script'); s.async=true;
    s.src='https://www.googletagmanager.com/gtag/js?id='+AW;
    document.head.appendChild(s);
    gtag('js', new Date());
    gtag('config', AW, {send_page_view:false});
    gtag('config', GA4, {send_page_view:false});
  }
  function esWhatsapp(a){
    if(!a) return false;
    if(a.classList && a.classList.contains('header-actions__action--whatsapp')) return true;
    return RE.test(a.getAttribute('href')||'');
  }
  document.addEventListener('click', function(ev){
    try{
      var a=ev.target && ev.target.closest && ev.target.closest('a[href], .header-actions__action--whatsapp');
      if(!esWhatsapp(a)) return;
      var ahora=Date.now(); if(ahora-ultimo<3000) return; ultimo=ahora;
      var mkt=permiso('marketing'), ana=permiso('analytics');
      if(!mkt && !ana) return;
      cargar();
      var donde=(a.className && String(a.className).indexOf('header-actions__action--whatsapp')>=0) ? 'cabecera' : 'enlace';
      if(mkt) gtag('event','conversion',{send_to:SEND_TO, transport_type:'beacon'});
      if(ana) gtag('event','clic_whatsapp',{send_to:GA4, ubicacion:donde, pagina:location.pathname, transport_type:'beacon'});
    }catch(e){}
  }, true);
  // FUSFIT velocidad 31-oct: gtag.js (165 KB; la 3.ª carga de Google en la página, las otras 2 son del píxel de la app
  // Google & YouTube) ya NO se baja al terminar de cargar la página: se baja cuando el visitante VA a tocar WhatsApp
  // (dedo o ratón encima, o tecla sobre el enlace), un instante antes del clic. Los enlaces abren en otra pestaña o en la
  // app (target=_blank), así que la conversión, que queda en cola, sale igual. Quien no toca WhatsApp no lo baja nunca.
  function precargar(){ if(permiso('marketing')||permiso('analytics')) cargar(); }
  function intento(ev){
    if(cargado) return;
    var a=ev.target && ev.target.closest && ev.target.closest('a[href], .header-actions__action--whatsapp');
    if(esWhatsapp(a)) precargar();
  }
  ['pointerdown','touchstart','mouseover','focusin'].forEach(function(t){ document.addEventListener(t, intento, {passive:true, capture:true}); });
})();
